/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function CodeCaption({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#CodeCaption_svg__a)"><path d="M3.4 1A.6.6 0 0 1 4 .4h8a.6.6 0 1 1 0 1.2H4a.6.6 0 0 1-.6-.6M10.949 12.399a.6.6 0 0 1-.897-.798l1.645-1.851-1.645-1.851a.6.6 0 1 1 .896-.798l2 2.25a.6.6 0 0 1 0 .798zM5.899 12.449a.6.6 0 0 1-.847-.05l-2-2.25a.6.6 0 0 1 0-.798l2-2.25a.6.6 0 0 1 .896.798L4.303 9.75l1.645 1.851a.6.6 0 0 1-.05.847M9.094 6.085a.6.6 0 0 0-1.188-.17l-1 7a.6.6 0 0 0 1.188.17z" /><path fillRule="evenodd" d="M.4 6A2.6 2.6 0 0 1 3 3.4h10A2.6 2.6 0 0 1 15.6 6v7a2.6 2.6 0 0 1-2.6 2.6H3A2.6 2.6 0 0 1 .4 13zM3 4.6A1.4 1.4 0 0 0 1.6 6v7A1.4 1.4 0 0 0 3 14.4h10a1.4 1.4 0 0 0 1.4-1.4V6A1.4 1.4 0 0 0 13 4.6z" clipRule="evenodd" /></g><defs><clipPath id="CodeCaption_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;